import Vue from 'vue'
import msg from './index.vue'

const dialog = Vue.extend(msg);
let nId = 1;
const globalDialog = (data) => {
    let id = 'notice-1';
  return new Promise((resolve)=>{


    var MsgBox =new dialog({
      data: {
        attention: data.attention,
        content: data.content,
        ok_text:data.okText,
        cancel_text: data.cancelText,
        title: data.title,
        showIcon: data.showIcon,
      },
    })
    MsgBox.id=id;
    MsgBox.vm = MsgBox.$mount() // 挂载但是并未插入dom，是一个完整的Vue实例
    // MsgBox.vm.ok_text = that.$i18n.tc('views.public.sure');
    MsgBox.vm.showFlag = true;
    MsgBox.vm.okClick=()=> {
      resolve(true)
    };
    MsgBox.vm.cancelClick=()=> {
      resolve(false)

    };
    MsgBox.dom = MsgBox.vm.$el;
    document.body.appendChild(MsgBox.dom);// 将dom插入body
    MsgBox.dom.style.zIndex = nId + 1001 // 后插入的Notice组件z-index加一，保证能盖在之前的上面

  })

}
export default {
  install: Vue => {
    Vue.prototype.$globalDialog = globalDialog // 将Notice组件暴露出去，并挂载在Vue的prototype上
  }
}



// WEBPACK FOOTER //
// ./src/components/globalDialog/globalDialog.js